module.exports = __webpack_public_path__ + "static/media/chicago-hay.82f287cb.jpg";